(function () {
    'use strict';

    angular
        .module('app')
        .controller('WinbackStateOffersListController', WinbackStateOffersListController);

    WinbackStateOffersListController.$inject = ['API', 'alert', 'debug',];

    function WinbackStateOffersListController(API, alert, debug) {
        var vm = this;
        vm.searchTerm = '';
        vm.page = 1;
        vm.perPage = 20;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.listMeta = {};
        vm.loadingState = {
            winbackIsLoading: false
        };
        vm.loadPage = loadPage;

        activate();

        function activate() {
            loadWinbackStateOffers();
        }

        function clearSearch() {
            vm.searchTerm = '';
            vm.page = 1;
            loadWinbackStateOffers();
        }

        function search() {
            vm.page = 1;
            loadWinbackStateOffers();
        }

        function loadPage(newPageNumber) {
            vm.page = newPageNumber;
            loadWinbackStateOffers();
        }

        function loadWinbackStateOffers() {
            var promise = null;
            if (vm.searchTerm && vm.searchTerm.length > 2) {
                promise = API.WinbackStateOffer.search({
                    'q': vm.searchTerm,
                    'page': vm.page,
                    'per-page': vm.perPage,
                    'expand': 'winbackOffer',
                }).$promise;
            } else if (vm.searchTerm.length === 0) {
                promise = API.WinbackStateOffer.get({
                    'page': vm.page,
                    'per-page': vm.perPage,
                    'expand': 'winbackOffer',
                }).$promise;
            }

            if (promise) {
                vm.loadingState.winbackIsLoading = true;
                promise.then(function (response) {
                    vm.winbackStateOffers = response.items;
                    vm.listMeta = response._meta;
                    vm.loadingState.winbackIsLoading = false;
                }, function (response) {
                    debug.log(response);
                });
            }
        }
    }
})();